import { Box, Dialog as MuiDialog, dialogClasses } from '@mui/material'

import { Loader } from '../loader'

export type DialogSize = 'small' | 'medium' | 'large'

const getPaperSize = (size: DialogSize) => {
  switch (size) {
    case 'large': {
      return '900px'
    }
    case 'medium': {
      return '720px'
    }
    case 'small': {
      return '400px'
    }
  }
}

export type DialogProps = {
  open: boolean
  children: React.ReactNode
  onClose?: () => void
  size?: DialogSize
  /** To add custom paper width that differs from predefined size options */
  width?: string
  /** Adds circular progress indicator in place of content */
  isContentLoading?: boolean
}

export const Dialog = ({
  open,
  children,
  onClose,
  width,
  size = 'medium',
  isContentLoading = false,
}: DialogProps) => {
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      sx={{
        [`& .${dialogClasses.paper}`]: {
          maxWidth: 'none',
          width: width ?? getPaperSize(size),
          border: 'none',
        },
      }}
    >
      {isContentLoading ? (
        <Box
          minHeight={250}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Loader />
        </Box>
      ) : (
        children
      )}
    </MuiDialog>
  )
}
